import axios from 'axios';

const senaFunciones = {
    // Función para cargar los programas
    obtenerProgramas: async () => {
        try {
            const response = await axios.get('/api/programas/listall');
            console.log("Lista de programas:", response);
            return response.data.programas || []; // Retorna los programas si están disponibles
        } catch (error) {
            console.error("Error al obtener la lista de programas:", error.message);
            return []; // Retorna un arreglo vacío en caso de error
        }
    },

    // Función para cargar los centros
    obtenerCentros: async () => {
        try {
            const response = await axios.get('/api/centrosdeformacion/listall');
            console.log("Lista de centros:", response);
            return response.data.centros || []; // Retorna los centros si están disponibles
        } catch (error) {
            console.error("Error al obtener la lista de centros:", error.message);
            return []; // Retorna un arreglo vacío en caso de error
        }
    },

    obtenerGrupos: async () => {
        try {
            const response = await axios.get('/api/grupos/listall');
            console.log('Lista de grupos:', response);
            return response.data.grupos || [];
        } catch (error) {
            console.error('Error al obtener la lista de grupos', error.message);
            return[];
            
        }
    },


    // Función para cargar programas por ID de centro (ejemplo adicional)
    obtenerProgramasPorCentro: async (centroId) => {
        try {
            const response = await axios.get(`/api/programas/centro/${centroId}`);
            console.log("Programas por centro:", response);
            return response.data.programas || []; // Retorna los programas relacionados
        } catch (error) {
            console.error("Error al obtener los programas por centro:", error.message);
            return []; // Retorna un arreglo vacío en caso de error
        }
    }
};

export default senaFunciones;
